// Module
var code = "<div class=\"widget-content trend-widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-line-chart id=\"shewhart{{vm.guid}}\" chart-data=\"vm.data\" series=\"vm.series\" options=\"vm.options\" zoom-control=\"vm.item\"></wt-line-chart> </div>";
// Exports
module.exports = code;